const mutations = {
  SET_COUNTRIES (state, { countries }) {
    state.countries = countries
  }
}

export default mutations
